@if (navItemsTemplateRef()) {
  <ng-container *ngTemplateOutlet="navItemsTemplateRef()"></ng-container>
} @else if (navItemsComponentRef()) {
  <ng-container *ngComponentOutlet="navItemsComponentRef()"></ng-container>
} @else {
  <nav uipagenavcontent>
    @for (item of navItems(); track item) {
      <a
        uipagenavitem
        *appHasRole="item.role"
        [routerLink]="item.routerLink"
        routerLinkActive="item.routerLinkActive"
      >
        @if (item.icon) {
          <icon
            uipagenavicon
            [iconDefinition]="item.icon.iconDefinition!"
            [iconSize]="item.icon.iconSize"
            [iconColor]="item.icon.iconColor"
          ></icon>
        }
        <span uipagenavitemtitle> {{ item.title }} </span>
      </a>
    }
  </nav>
}
